import { render } from "./ContentModal.vue?vue&type=template&id=ca52b8ca&ts=true"
import script from "./ContentModal.vue?vue&type=script&lang=ts"
export * from "./ContentModal.vue?vue&type=script&lang=ts"

import "./ContentModal.vue?vue&type=style&index=0&id=ca52b8ca&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__